import { render } from "./OnboardingSuccessful.vue?vue&type=template&id=70c2e178&scoped=true"
import script from "./OnboardingSuccessful.vue?vue&type=script&lang=js"
export * from "./OnboardingSuccessful.vue?vue&type=script&lang=js"

import "./OnboardingSuccessful.vue?vue&type=style&index=0&id=70c2e178&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2e178"]])

export default __exports__